// client/src/hooks/useClasses.js
// CRUD hooks for the classes nested resource (wave-10). A class rename
// cascades to students server-side, so mutations also invalidate the
// students cache.

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

const listKey = (campId) => ['camps', campId, 'classes'];

export function useClasses(campId) {
  return useQuery({
    queryKey: listKey(campId),
    queryFn: () => api.get(`/api/camps/${campId}/classes`).then((r) => r.classes),
    enabled: !!campId,
  });
}

function invalidate(qc, campId) {
  qc.invalidateQueries({ queryKey: listKey(campId) });
  // Renames rewrite student.className; keep the students views fresh.
  qc.invalidateQueries({ queryKey: ['camps', campId, 'students'] });
}

export function useCreateClass(campId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post(`/api/camps/${campId}/classes`, body),
    onSuccess: () => invalidate(qc, campId),
  });
}

export function useUpdateClass(campId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ classId, patch }) =>
      api.patch(`/api/camps/${campId}/classes/${classId}`, patch),
    onSuccess: () => invalidate(qc, campId),
  });
}

export function useDeleteClass(campId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (classId) => api.delete(`/api/camps/${campId}/classes/${classId}`),
    onSuccess: () => invalidate(qc, campId),
  });
}
